import { isProductionHost } from '@/domain/environment';

/* Public endpoint that already feeds the marketing site map. It answers with
   `access-control-allow-origin: *`, so the browser can read it directly and this
   page needs no backend of its own. */
const DEFAULT_STATIONS_URL = 'https://services.vammo.com/v1/public-swap-stations/map';

/* Vammo Forms (Formbricks). The lead's name and number go here rather than to
   analytics: Google's policy forbids personal data in GA whatever the lead consents to,
   ad blockers drop a share of those hits with no trace, and the GA export lands a day
   later through BigQuery — none of which a sales list survives. The workspace id is not
   a secret; it is served in the public survey page, and the client endpoint is public by
   design. */
const DEFAULT_FORMS_URL = 'https://forms.vammo.com';
const DEFAULT_FORMS_WORKSPACE_ID = 'cmsdpm5g0000108obqvl4orry';
const PRODUCTION_NOTIFY_SURVEY_ID = 'cmtbqb5f701jd07o9m6e5zcf9';
const TEST_NOTIFY_SURVEY_ID = 'cmtbqr51m01jq07o9qsi1viap';

export const config = {
  stationsUrl: import.meta.env.VITE_STATIONS_URL ?? DEFAULT_STATIONS_URL,
  gtmId: import.meta.env.VITE_GTM_ID ?? '',
  formsUrl: import.meta.env.VITE_FORMS_URL ?? DEFAULT_FORMS_URL,
  formsWorkspaceId: import.meta.env.VITE_FORMS_WORKSPACE_ID ?? DEFAULT_FORMS_WORKSPACE_ID,
  /* Only the canonical host writes to the survey sales reads. Develop and any local
     preview go to the test survey, or every dogfood run becomes a lead somebody calls. */
  notifySurveyId:
    import.meta.env.VITE_NOTIFY_SURVEY_ID ??
    (isProductionHost(window.location.hostname)
      ? PRODUCTION_NOTIFY_SURVEY_ID
      : TEST_NOTIFY_SURVEY_ID),
};
